import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { addItemsToCart } from '../../../actions/shop';

import {
    Button
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';

const Reorder = ({ products, buttonData }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { full_width, variant, color } = buttonData;

    const [disabled, setDisabled] = useState(false);

    // agregar productos a carrito
    const reorder = () => {
        setDisabled(true);
        const items = products.map(({
            prod_id, prod_var_id, title, variant_title,
            quantity
        }) => ({
            prod_id, prod_var_id, title, variant_title,
            quantity
        }));
        if (items.length > 0)
            dispatch(addItemsToCart(
                items, () => {}, () => {},
                { flag: true, navigate }
            ));
    };

    return (
        disabled ?
            <LoadingButton loading
                fullWidth={ full_width }
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="outlined"
                sx={{ textTransform: 'none' }}>
                Agregando a carrito
            </LoadingButton>
        :
            <Button
                fullWidth={ full_width }
                variant={ variant }
                color={ color }
                disabled={ disabled }
                sx={{ textTransform: 'none' }}
                onClick={ reorder }>
                Agregar todo al carrito
            </Button>
    );
};

export default Reorder;